import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/manutencao`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioSolicitacoes(queryParms) {
            return repository.get(`${baseUrl}/relatorio-solicitacoes?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
